import styled from "styled-components"

export const FoodImageBox = styled.div`
  height: 256px;
  width: 100%;
  position: relative;
`

export const ImageBottomOverlay = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(250, 251, 251, 0.48) 66.5%,
    #f5f7f7 100%
  );

  height: 24px;
  position: absolute;
  bottom: 0;
  width: 100%;
`

export const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`

export const FoodImagePlaceholder = styled.img`
  width: 100%;
  height: 256px;
  object-fit: cover;
`

